// extracted by mini-css-extract-plugin
export default {"CardLink":"CardLink_CardLink__7ROrr","Link":"CardLink_Link__hQDgq"};